import CostOvertimeIndex from "./CostOvertimeIndex.vue";
import CostOvertimeAdd from "./CostOvertimeAdd.vue";
import CostOvertimeDetail from "./CostOvertimeDetail.vue";
import CostOvertimeEdit from "./CostOvertimeEdit.vue";
import CostOvertimeUpload from "./CostOvertimeUpload.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List Cost Overtime",
        },
        name: "CostOvertimeIndex",
        component: CostOvertimeIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Cost Overtime",
        },
        name: "CostOvertimeAdd",
        component: CostOvertimeAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Cost Overtime",
        },
        name: "CostOvertimeDetail",
        component: CostOvertimeDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Cost Overtime",
        },
        name: "CostOvertimeEdit",
        component: CostOvertimeEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Upload Cost Overtime",
        },
        name: "CostOvertimeUpload",
        component: CostOvertimeUpload
    },
    
]

export default routes
  